import * as React from 'react';

const BackToTopIcon = (props) => {
  return (
    <svg
      width="13"
      height="19"
      viewBox="0 0 13 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.668115 7.22294C0.700756 7.40577 0.835159 7.55051 1.0118 7.60193C1.19229 7.65335 1.38237 7.60003 1.50909 7.46671L5.99815 3.01405L5.99815 17.3243C5.99815 17.3395 5.99815 17.3547 5.99815 17.37C6.00967 17.6366 6.24007 17.8461 6.50888 17.8328C6.77768 17.8194 6.98697 17.5928 6.97353 17.3243L6.97353 3.01405L11.4626 7.46671C11.5816 7.60955 11.7698 7.67621 11.9541 7.63431C12.1346 7.59241 12.2786 7.45148 12.3208 7.27055C12.3631 7.08963 12.2959 6.90108 12.15 6.78491L6.8372 1.49999L6.48583 1.16671L6.13447 1.49999L0.821718 6.78491C0.712276 6.88585 0.656595 7.03059 0.668115 7.17914C0.668115 7.19437 0.668115 7.2077 0.668115 7.22294Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
};

export default BackToTopIcon;
